import styled from "styled-components";

export const Container = styled.div`
    padding: 10px;
`

export const Topper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px,
`

export const FlexWrapper = styled.div`
    flex: 1;
`

export const NavBar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    overflow: hidden;
    margin-bottom: 30px;
`

export const MenuItemContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 22px;
`